import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem("token")}` };
}

export const getDdpImportTarifas = async () => {
  const response = await axios.get(`${API_URL}/api/ddp-import-tarifas`, {
    headers: authHeaders(),
  });
  return response.data?.tarifas || [];
};

export const saveDdpImportTarifa = async (subgrupoId, payload) => {
  const response = await axios.put(
    `${API_URL}/api/ddp-import-tarifas/${subgrupoId}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data?.tarifa;
};
